var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome"},[_c('div',{staticClass:"welcome-wrapper"},[_c('h1',[_vm._v("欢迎登录")]),_vm._v(" "),_c('div',{staticClass:"welcome-content"},[_c('p',[_vm._v("欢迎进入体质健康服务平台")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-912b0b58","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/welcome/welcome.vue
// module id = gXiK
// module chunks = 94